export default "__VITE_ASSET__f8509ee7__"